module.exports = __webpack_public_path__ + "img/volume-icon.8697fb7f.svg";